"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//import fm = require('./../Scripts/fm');
//import websync = require("../FrozenMountain/fm.websync");
//import "../Scripts/fm.websync.subscribers.js";
//import "../Scripts/fm.websync.chat.js";
const EventEmitter = require("wolfy87-eventemitter");
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
const ProtocolConstant = require("../../Protocol/ProtocolConstant");
const ExponentialBackoffHelper = require("../../Common/ExponentialBackoffHelper");
const LogManager_1 = require("../../Log/LogManager");
const CommonBaseError_1 = require("../../Common/CommonBaseError");
class Signalling {
    constructor(websyncServerUrl) {
        this._logger = LogManager_1.logManager.GetLogger("Signalling");
        this.WebSyncServerUrl = '';
        this.WebSyncClient = null;
        // IceLink includes a WebSync client extension that will
        // automatically manage signalling for you. If you are not
        // using WebSync, set this to false to see how the event
        // system works. Use it as a template for your own code.
        this.UseWebSyncExtension = true;
        this._needToRetry = true;
        //need to use ConcurrentDictionary to maintain thread safe.
        this._signallingResDic = new Map();
        this.errorOccurred = new EventEmitter();
        this.WebSyncServerUrl = websyncServerUrl;
    }
    async startAsync(userid, username, token, requestTimeout, importedWebsync) {
        this._logger.debug(`Starting signaling with user=${username}, token.Length=${token.length}`);
        if (importedWebsync) {
            this._websync = importedWebsync;
            this._logger.debug(`Using imported WebSync.`);
        }
        else {
            const globalFm = window.fm;
            if (typeof globalFm === 'undefined')
                throw new SignallingError("No global fm, can not start Signalling.");
            const globalWebSync = globalFm.websync;
            if (typeof globalWebSync === 'undefined')
                throw new SignallingError("No global fm.websync, No imported fm.websync, can not start Signalling.");
            this._websync = globalWebSync;
            this._logger.debug(`Using global Websync.`);
        }
        //this._websync.client.enableMultiple = true; //no need to use multiple websync client
        this.WebSyncClient = this.buildWebSyncClient(userid, username, token, requestTimeout);
        let curRetryCount = 0;
        return new Promise((resolve, reject) => {
            this._logger.info(`Connecting to ${this.WebSyncServerUrl}...`);
            const connectArgs = new this._websync.connectArgs();
            connectArgs.setOnSuccess((connectSuccessArgs) => {
                if (!connectSuccessArgs.getIsReconnect()) {
                    this._logger.info(`Connected to ${this.WebSyncServerUrl}.`);
                }
                else {
                    this._logger.info(`Reconnected to ${this.WebSyncServerUrl}.`);
                }
                curRetryCount = 0;
            });
            connectArgs.setOnFailure((connectFailureArgs) => {
                connectFailureArgs.setRetry(true);
                ++curRetryCount;
                const failureMsg = `WebSyncClient.Connect: Could not connect to WebSync, Retry=${connectFailureArgs.getRetry()}, RetryCount=${curRetryCount}, ${connectFailureArgs.getException()}`;
                this._logger.error(failureMsg);
                this.errorOccurred.emitEvent(exports.SignallingErrorName, [new ConnectionNotAvaliableError(failureMsg, connectFailureArgs.getException())]);
            });
            connectArgs.setOnComplete((connectCompleteArgs) => {
                resolve();
            });
            connectArgs.setRetryBackoff((backoffArgs) => {
                const nextDelayTimeMs = ExponentialBackoffHelper.NextDelayTimeMsFromExponentialBackoff(curRetryCount);
                this._logger.debug(`Calculate nextDelayTime: RetryCount=${curRetryCount}, nextDelayTimeMs=${nextDelayTimeMs}`);
                return nextDelayTimeMs;
            });
            connectArgs.setOnStreamFailure((streamFailureArgs) => {
                streamFailureArgs.setRetry(this._needToRetry);
                const streamFailureMsg = `WebSyncClient.Connect: Stream Failure, Retry=${streamFailureArgs.getRetry()}, ${streamFailureArgs.getException()}`;
                this._logger.error(streamFailureArgs);
                this.errorOccurred.emitEvent(exports.SignallingErrorName, [new ConnectionNotStableError(streamFailureMsg, streamFailureArgs.getException())]);
            });
            const userNameToken = {};
            if (userid)
                userNameToken[ProtocolConstant.RTC_CONNECT_ID] = userid;
            if (username)
                userNameToken[ProtocolConstant.RTC_CONNECT_NAME] = username;
            if (token)
                userNameToken[ProtocolConstant.RTC_CONNECT_USER_VALIDATION_TOKE_KEY_NAME] = token;
            const metaJson = JSON.stringify(userNameToken);
            connectArgs.setMetaJson(metaJson);
            this.WebSyncClient.connect(connectArgs);
            /*
            this.WebSyncClient.connect({
              onSuccess: (connectSuccessArgs: any) => {
                if (!connectSuccessArgs.getIsReconnect()) {
                  console.info(`Connected to ${this.WebSyncServerUrl}.`);
                } else {
                  console.info(`Reconnected to ${this.WebSyncServerUrl}.`);
                }
                curRetryCount = 0;
                resolve();
              },
              onFailure: (connectFailureArgs: any) => {
                connectFailureArgs.setRetry(true);
                ++curRetryCount;
                const failureMsg = `WebSyncClient.Connect: Could not connect to WebSync, Retry=${connectFailureArgs.getRetry()}, RetryCount=${curRetryCount}, ${connectFailureArgs.getException()}`;
                console.error(failureMsg);
                this.errorOccurred.emitEvent(SignallingError, new ConnectionNotAvaliable());
              },
              onComplete: (connectCompleteArgs: any) => {
                resolve();
              },
              retryBackoff: (backoffArgs: any) => {
                const nextDelayTimeMs: number = ExponentialBackoffHelper.NextDelayTimeMsFromExponentialBackoff(curRetryCount);
                console.debug(`Calculate nextDelayTime: RetryCount=${curRetryCount}, nextDelayTimeMs=${nextDelayTimeMs}`);
                return nextDelayTimeMs;
              },
              onStreamFailure: (streamFailureArgs: any) => {
                streamFailureArgs.setRetry(this._needToRetry);
                const streamFailureMsg = `WebSyncClient.Connect: Stream Failure, Retry=${streamFailureArgs.getRetry()}, ${streamFailureArgs.getException()}`;
                console.error(streamFailureArgs);
      
                this.errorOccurred.emit(SignallingError, new ConnectionNotStable());
              }
            });
            */
        }).catch(error => { throw error; });
    }
    buildWebSyncClient(id, username, token, requestTimeout = 15000) {
        // Create a WebSync client.
        let websyncClient = this.WebSyncClient;
        if (!websyncClient) {
            websyncClient = new this._websync.client(this.WebSyncServerUrl);
        }
        //websyncClient.setRequestTimeout(15000);
        websyncClient.setRequestTimeout(requestTimeout);
        websyncClient.setAutoDisconnect({ synchronous: true });
        //this.WebSyncClient.setDomainKey(new fm.guid('5fb3bdc2-ea34-11dd-9b91-3e6b56d89593')); // WebSync On-Demand
        return websyncClient;
    }
    async stopAsync() {
        if (!this.WebSyncClient)
            return;
        return new Promise((resolve, reject) => {
            this.WebSyncClient.disconnect({
                onComplete: (disconnectCompleteArgs) => {
                    resolve();
                }
            });
        });
    }
    isConnected() {
        if (!this.WebSyncClient)
            return false;
        return this.WebSyncClient.getIsConnected();
    }
    async bindAsync(bindingKey, bindingValue) {
        return new Promise((resolve, reject) => {
            this.WebSyncClient.bind({
                record: { key: bindingKey, valueJson: bindingValue },
                onSuccess: (bindSuccessArgs) => {
                    if (!bindSuccessArgs.getIsRebind()) {
                        this._logger.debug(`Binding ${bindingKey} succeeded.`);
                    }
                    else {
                        this._logger.debug(`Rebinding ${bindingKey} succeeded.`);
                    }
                    resolve();
                },
                onFailure: (bindFailureArgs) => {
                    const errorMsg = `Binding ${bindingKey} failed. reason=${bindFailureArgs.getException()}`;
                    this._logger.error(errorMsg);
                    reject(bindFailureArgs.getException());
                }
            });
        })
            .catch(error => { throw error; });
    }
    async unbindAsync(bindingKey) {
        return new Promise((resolve, reject) => {
            this.WebSyncClient.unbind({
                key: bindingKey,
                onSuccess: (unbindSuccessArgs) => {
                    this._logger.debug(`Unbinding ${bindingKey} succeeded.`);
                },
                onFailure: (unbindFailureArgs) => {
                    this._logger.debug(`Unbinding ${bindingKey} failed.`);
                },
                onComplete: (unbindCompleteArgs) => {
                    this._logger.debug(`Unbinding ${bindingKey} completed.`);
                    resolve();
                }
            });
        }).catch(error => { throw error; });
    }
    async subscribeAsync(channelName, channelHandler) {
        if (this.WebSyncClient.getIsConnecting()) {
            await this.WaitForConnect();
        }
        return new Promise((resolve, reject) => {
            this.WebSyncClient.subscribe({
                channel: channelName,
                onSuccess: (subscribeSuccessArgs) => {
                    if (!subscribeSuccessArgs.getIsResubscribe()) {
                        this._logger.debug(`Subscribe ${channelName} succeeded.`);
                    }
                    else {
                        this._logger.debug(`Resubscribe ${channelName} succeeded.`);
                    }
                    resolve(subscribeSuccessArgs.getMetaJson());
                },
                onFailure: (subscribeFailureArgs) => {
                    //subscribeFailureArgs.setRetry(this._needToRetry);//Not sure need to retry or not.
                    const error = subscribeFailureArgs.getException();
                    this._logger.error(error.message);
                    this.errorOccurred.emitEvent(exports.SignallingErrorName, [error]);
                    reject();
                },
                onReceive: async (subscribeReceiveArgs) => {
                    if (subscribeReceiveArgs.getChannel().includes(channelName)) {
                        //this._logger.trace(`Receive ${channelName}: ${subscribeReceiveArgs.getDataJson()}`);
                        this._logger.debug(`Receive ${channelName}: `);
                        await channelHandler(subscribeReceiveArgs.getIsBinary(), subscribeReceiveArgs.getDataJson(), subscribeReceiveArgs.getDataBytes());
                    }
                    else {
                        this._logger.error(`Receive strange channel ${channelName}`);
                    }
                }
            });
        }).catch(error => { throw error; });
    }
    async unSubscribeAsync(channelNames) {
        if (typeof channelNames === 'string') {
            return new Promise((resolve, reject) => {
                this.WebSyncClient.unsubscribe({
                    channel: channelNames,
                    onSuccess: (unsubscribeSuccessArgs) => {
                        this._logger.debug(`Unsubscribing ${channelNames} succeeded.`);
                    },
                    onFailure: (unsubscribeFailureArgs) => {
                        this._logger.debug(`Unsubscribing ${channelNames} failed.`);
                    },
                    onComplete: (unsubscribeCompleteArgs) => {
                        this._logger.debug(`Unsubscribing ${channelNames} completed.`);
                        resolve();
                    },
                });
            });
        }
        else {
            return new Promise((resolve, reject) => {
                this.WebSyncClient.unsubscribe({
                    channels: channelNames,
                    onSuccess: (unsubscribeSuccessArgs) => {
                        this._logger.debug(`Unsubscribing ${JSON.stringify(channelNames)} succeeded.`);
                    },
                    onFailure: (unsubscribeFailureArgs) => {
                        this._logger.debug(`Unsubscribing ${JSON.stringify(channelNames)} failed.`);
                    },
                    onComplete: (unsubscribeCompleteArgs) => {
                        this._logger.debug(`Unsubscribing ${JSON.stringify(channelNames)} completed.`);
                        resolve();
                    },
                });
            });
        }
    }
    async publishToChannelAsync(channel, cmJson) {
        return new Promise((resolve, reject) => {
            this.WebSyncClient.publish({
                channel: channel,
                dataJson: cmJson,
                onSuccess: (publishSuccessArgs) => {
                    this._logger.debug(`Publish to ${channel} succeeded.`);
                    resolve();
                },
                onFailure: (publishFailureArgs) => {
                    this._logger.error(`Publish to ${channel} failed, reason=${publishFailureArgs.getException()}`);
                    reject(publishFailureArgs.getException());
                }
            });
        }).catch(err => { throw err; });
    }
    /**
     *
     *
     * @param {fm.icelink.conference} conference
     * @param {string} sessionId
     * @param {boolean} [needToUseWebSyncExt=true]
     * @returns {Promise<void>}
     * @memberof Signalling
     */
    async attachAsync(conference, sessionId, needToUseWebSyncExt = true) {
        this._logger.debug(`Starting attach of ${sessionId}, with needToUseWebSyncExt=${needToUseWebSyncExt}`);
        return new Promise((resolve, reject) => {
            if (needToUseWebSyncExt) {
                this.WebSyncClient.joinConference({
                    conferenceChannel: '/' + sessionId,
                    conference: conference,
                    onSuccess: (e) => {
                        this._logger.debug(`Join conference session ${sessionId} succeeded.`);
                        resolve();
                    },
                    onFailure: (e) => {
                        this._logger.error(`Could not attach signalling to conference ${sessionId}. ${e.getException().message}`);
                        reject(e.getException());
                    },
                });
            }
        });
    }
    async detachAsync(sessionId, needToUseWebSyncExt = true) {
        this._logger.debug(`Starting detach from ${sessionId}`);
        return new Promise((resolve, reject) => {
            if (needToUseWebSyncExt) {
                // Leave the managed WebSync channel.
                this.WebSyncClient.leaveConference({
                    conferenceChannel: '/' + sessionId,
                    onSuccess: (e) => {
                        this._logger.debug(`Detach ${sessionId} succeeded by using WebSyncExtension`);
                        resolve();
                    },
                    onFailure: (e) => {
                        this._logger.error(`Could not detach signalling from conference ${sessionId}. ${e.getException().message}`);
                        reject(e.getException());
                    },
                });
            }
        });
    }
    async requestServiceAsync(channel, dataJson) {
        if (this.WebSyncClient.getIsConnecting()) {
            await this.WaitForConnect();
        }
        return new Promise((resolve, reject) => {
            this.WebSyncClient.service({
                channel: channel,
                dataJson: dataJson,
                onSuccess: (serviceSuccessArgs) => {
                    //this._logger.debug(`Succeeded to request service on ${this.WebSyncServerUrl}${channel} with ${dataJson}`);
                    this._logger.debug(`Succeeded to request service on ${this.WebSyncServerUrl}${channel}`);
                    const result = serviceSuccessArgs.getDataJson();
                    resolve(result);
                },
                onFailure: (serviceFailureArgs) => {
                    const errorMsg = `Failed to request service on ${this.WebSyncServerUrl}${channel} with ${dataJson}`;
                    this._logger.error(errorMsg);
                    this.errorOccurred.emitEvent(exports.SignallingErrorName, [new SignallingError(errorMsg, serviceFailureArgs.getException())]);
                    resolve("");
                },
            });
        })
            .catch(err => { throw err; });
    }
    async WaitForConnect() {
        const WAITING_INTERVAL = 1000;
        this._logger.debug("Start waiting");
        await TypeScriptUtils_1.delay(WAITING_INTERVAL);
        this._logger.debug(`${WAITING_INTERVAL}ms waited.`);
        if (this.WebSyncClient.getIsConnected())
            return;
        await TypeScriptUtils_1.delay(WAITING_INTERVAL);
        this._logger.debug(`${WAITING_INTERVAL * 2}ms waited.`);
        if (this.WebSyncClient.getIsConnected())
            return;
        await TypeScriptUtils_1.delay(WAITING_INTERVAL);
        this._logger.debug(`${WAITING_INTERVAL * 3}ms waited.`);
    }
}
exports.Signalling = Signalling;
exports.SignallingErrorName = "SignallingError";
class SignallingError extends CommonBaseError_1.CommonBaseError {
}
exports.SignallingError = SignallingError;
class ConnectionNotStableError extends SignallingError {
}
exports.ConnectionNotStableError = ConnectionNotStableError;
class ConnectionNotAvaliableError extends SignallingError {
}
exports.ConnectionNotAvaliableError = ConnectionNotAvaliableError;
class SignallingResource {
    get id() { return this._id; }
    get conference() { return this._conference; }
    constructor(id, c) {
        this._id = id;
        this._conference = c;
    }
}
//# sourceMappingURL=Signalling.js.map